module.exports = __webpack_public_path__ + "img/attention_rounded_blue.256d5f2f.svg";